export default function(h, row, index) {
    //let _s1 =  '#' + row.user_id + ': ' +  row.user_firstname + ' ' + row.user_lastname + ' (' + row.user_login + ')';
    let _s1 = ''
    if (row.user_id && row.user)
        _s1 =  row.user.name_ + ' ' + row.user.patro   + ' ' + row.user.surname ;
    return <span>{_s1}</span>
}
